var $66a0cc6081a76bcf$exports = {};
$66a0cc6081a76bcf$exports = {
    "colorFormat": `\u{989C}\u{8272}\u{683C}\u{5F0F}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$66a0cc6081a76bcf$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
